import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, LoginPage, RegisterPage, ProtectedRoute } from "./auth";
import { Layout } from "./components/Layout";
import { RedirectHome } from "./components/RedirectHome";
import { Dashboard } from "./pages/Dashboard";
import { Search } from "./pages/Search";
import { History } from "./pages/History";
import { Profile } from "./pages/Profile";
import { Payment } from "./pages/Payment";
import { Admin } from "./pages/Admin";
import { APIDocs } from "./pages/APIDocs";
import { 
  UsersManagement, 
  PaymentsManagement, 
  SystemSettings, 
  Statistics, 
  TelegramAccounts, 
  IPExceptions,
  IndicesManagement 
} from "./admin";
import "./index.css";



export function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<RedirectHome />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* Protected routes with Layout */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="search" element={<Search />} />
            <Route path="history" element={<History />} />
            <Route path="profile" element={<Profile />} />
            <Route path="payment" element={<Payment />} />
            <Route path="admin" element={<Admin />} />
            <Route path="admin/users" element={<UsersManagement />} />
            <Route path="admin/payments" element={<PaymentsManagement />} />
            <Route path="admin/settings" element={<SystemSettings />} />
            <Route path="admin/statistics" element={<Statistics />} />
            <Route path="admin/telegram" element={<TelegramAccounts />} />
            <Route path="admin/ip-exceptions" element={<IPExceptions />} />
            <Route path="admin/indices" element={<IndicesManagement />} />
            <Route path="apidocs" element={<APIDocs />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
